import { alpha, styled, SxProps, TableRow, Theme } from '@mui/material';

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: alpha(
      theme.palette.primary.light,
      theme.palette.action.activatedOpacity - 0.02
    ),
  },
}));

const styles: SxProps<Theme> = {};

export default styles;
